import React from 'react';
import Config from '../../../Config';

class Freesignup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'password',
            _id: "",
            Name: "",
            Email: "",
            Password: "",
            CPassword: "",
            PasswordError: "",
            EmailError: "",
            errorMessage: "",

        }
        this.showHide = this.showHide.bind(this);
    }

    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type === 'input' ? 'password' : 'input'
        })
    }

    onChangeName = (event) => {
        this.setState({ Name: event.target.value });
    }

    onChangeEmail = (event) => {
        this.setState({
            Email: event.target.value,
            EmailError: ""
        }, function () {
        });
    }

    onChangePassword = (event) => {
        this.setState({
            Password: event.target.value,
            PasswordError: ""
        }, function () {
        });
    }

    onChangeConfirmPassword = (event) => {
        this.setState({
            CPassword: event.target.value,
            PasswordError: ""
        }, function () {
        });
    }

    CreateRegister() {
        if (this.state.Name != "" && this.state.Name != null && this.state.Name != undefined &&
            this.state.Email != "" && this.state.Email != null && this.state.Email != undefined &&
            this.state.Password != "" && this.state.Password != null && this.state.Password != undefined &&
            this.state.CPassword != "" && this.state.CPassword != null && this.state.CPassword != undefined) {
            let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
            var isValidForm = true;

            if (reg.test(this.state.Email) === false) {
                isValidForm = false;
                this.setState({
                    EmailError: "Sorry! Email is not in correct format."
                }, function () {
                });
            } else {
                this.setState({
                    EmailError: ""
                }, function () {
                });
            }

            if (this.state.Password != this.state.CPassword) {
                isValidForm = false;
                this.setState({
                    PasswordError: "Sorry! Repeat password do not match. Please re-enter."
                }, function () {
                });
            } else {
                this.setState({
                    PasswordError: ""
                }, function () {
                });
            }

            if (isValidForm) {
                var data = {
                    Name: this.state.Name,
                    Email: this.state.Email,
                    Password: this.state.Password,
                    RegistrationType:"Free"
                }

                fetch(Config.apiUrl + "Login/signup",
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*'
                        },
                        body: JSON.stringify(data)
                    }).then((result) => {
                        result.json().then((resp) => {
                            if (resp.responseMessage == "success") {
                                this.props.history.push("/Login1");
                            } else {
                                this.setState({
                                    errorMessage: resp.responseMessage
                                }, function () {
                                });
                            }
                        })
                    })
            }
        }
    }

    registerclearform() {
        this.setState({
            Email: "",
            Password: "",
            CPassword: "",
            _id: ""
        });
    }


    render() {
        return (
            <div id="page-container" class="fade page-sidebar-fixed page-header-fixed">
                <div className="login login-with-news-feed">
                    <div className="news-feed">
                        <div className="news-image" style={{ backgroundImage: 'url(../assets/img/login-bg/login-bg-11.jpg)' }} />
                    </div>

                    <div className="right-content">
                        <div className="login-header d-flex justify-content-center align-items-center m-b-40">
                            <img src="../assets/img/logo/STT-Logo.png" alt="" style={{ height: '45px' }}></img>
                            <span className="brand-Name">STT</span>
                        </div>

                        <div className="login-content">
                            <form action="index.html" method="GET" className="margin-bottom-0 login-container shadow-add">
                                <div className="form-group  m-b-15">
                                    <label className="login-input">Name  </label>
                                    <input type="text"
                                        className="form-control form-control-lg"
                                        placeholder="Enter Your Name"
                                        value={this.state.Name}
                                        onChange={this.onChangeName}
                                    />
                                </div>
                                <div className="form-group  m-b-15">
                                    <label className="login-input">Email  </label>
                                    <input type="text"
                                        className="form-control form-control-lg"
                                        placeholder="Enter Your Email"
                                        value={this.state.Email}
                                        onChange={this.onChangeEmail}
                                    />
                                </div>

                                {(this.state.EmailError != "" && this.state.EmailError != null) ?
                                    <div className="m-t-20 m-b-20 col-md-12 text-red">
                                        {this.state.EmailError}
                                    </div>
                                    : ""}

                                <div className="form-group m-b-15">
                                    <label className="login-input">Password</label>
                                    <div class="input-group">
                                        <input type={this.state.type}
                                            className="form-control password__input form-control-lg"
                                            placeholder="Enter Your Password"
                                            value={this.state.Password}
                                            onChange={e => this.onChangePassword(e)}
                                            maxLength={15}
                                            required
                                        />
                                        <span className="input-group-text password__show " onClick={this.showHide}>{this.state.type === 'input' ? <i className="fas fa-eye-size fa-fw  fa-eye"></i> : <i className="fas fa-eye-size fa-fw fa-eye-slash"></i>}</span>
                                    </div>
                                </div>

                                <div className="form-group m-b-15">
                                    <label className="login-input">Repeat Password</label>
                                    <div class="input-group">
                                        <input type={this.state.type}
                                            className="form-control password__input form-control-lg"
                                            placeholder="Enter Your Password"
                                            value={this.state.CPassword}
                                            onChange={e => this.onChangeConfirmPassword(e)}
                                            maxLength={15}
                                            required
                                        />
                                        <span className="input-group-text password__show " onClick={this.showHide}>{this.state.type === 'input' ? <i className="fas fa-eye-size fa-fw  fa-eye"></i> : <i className="fas fa-eye-size fa-fw fa-eye-slash"></i>}</span>
                                    </div>
                                </div>

                                {(this.state.PasswordError != "" && this.state.PasswordError != null) ?
                                    <div className="m-t-20 m-b-20 col-md-12 text-red">
                                        {this.state.PasswordError}
                                    </div>
                                    : ""}

                                <div className="login-buttons">
                                    <button type="button" onClick={() => { this.CreateRegister() }} className="btn btn-primary btn-block  sign-button">Sign up</button>
                                </div>
                                {(this.state.errorMessage != "" && this.state.errorMessage != null) ?
                                    <div className="m-t-20 m-b-20 col-md-12 text-red">
                                        {this.state.errorMessage}
                                    </div>
                                    : ""}

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Freesignup;